import { useTypedSelector } from "@/redux/helpers/hooks.ts";

export const useCurrentPageLoading = () => {
  return useTypedSelector((state) => state.admin.loading);
};
